import React from "react";
import { Link } from "react-router-dom";
import { motion } from "motion/react";
import { Heart, ArrowRight } from "lucide-react";
import Layout from "../components/layout/Layout";
import ExpertCard from "../components/ui/ExpertCard";
import { useFavorites } from "../context/FavoritesContext";
import { useExperts } from "../hooks/useExperts";

export default function FavoritesPage() {
  const { favorites } = useFavorites();
  const { experts: dbExperts } = useExperts();
  const favoriteExperts = dbExperts.filter((e) => favorites.includes(e.id));

  return (
    <Layout>
      <div id="favorites_page" className="min-h-screen py-8 lg:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-8"
          >
            <h1 className="text-3xl lg:text-4xl font-medium text-white mb-2">
              Избранные эксперты
            </h1>
            <p className="text-lg font-extralight text-neutral-400">
              {favoriteExperts.length > 0
                ? `${favoriteExperts.length} эксперт${favoriteExperts.length === 1 ? "" : favoriteExperts.length < 5 ? "а" : "ов"} в избранном`
                : "Пока пусто"}
            </p>
          </motion.div>

          {favoriteExperts.length === 0 ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center py-20"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-neutral-800 flex items-center justify-center">
                <Heart className="w-10 h-10 text-neutral-500" />
              </div>
              <h2 className="text-2xl font-medium text-white mb-3">
                Нет избранных экспертов
              </h2>
              <p className="text-lg font-extralight text-neutral-400 mb-8 max-w-md mx-auto">
                Добавляйте экспертов в избранное, чтобы быстро находить их позже
              </p>
              <Link
                to="/experts"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-600 hover:bg-primary-500 text-white text-lg font-medium transition-colors"
              >
                Найти экспертов
                <ArrowRight className="w-5 h-5" />
              </Link>
            </motion.div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {favoriteExperts.map((expert) => (
                <ExpertCard key={expert.id} expert={expert} />
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
